<script>
import Base from "@/components/RequestDetails/RequestLog.vue";

export default {
  name: "DefaultViewRequestLog",
  extends: Base,
};
</script>

